export const _ADD               = "682R6NTY6gV2g4Vf5JjSOA==";
export const _EDIT              = "J6St7ZtSW0mv26UW2yRASw==";
export const _VIEW              = "fDlbhgERxF+FJtQEKce3AA==";
export const _DELETE            = "UsZHQpgjQocg5zTNKO+uiw==";
export const _RECOVER           = "RbY6LRyQQf2MLZIP0zuMog==";
export const _LIST              = "5TCgd+S/IjlwkGmk+AWnTg==";
export const _TRASH             = "FFWyOfX0wScmmV/Rq3HB/g==";